import React, { Fragment } from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import { translate } from "sulu-admin-bundle/utils";
import { Requester } from "sulu-admin-bundle/services";
import Button from "sulu-admin-bundle/components/Button";
import Toggler from "sulu-admin-bundle/components/Toggler";
import styles from "./PrivacyConsentDialog.module.scss";

const CONSENT_ENDPOINT = "/admin/api/privacy-consent";

@observer
class PrivacyConsentDialog extends React.Component {
    @observable policyAccepted = false;
    @observable marketingAccepted = false;
    @observable submitting = false;
    @observable errorMessage = null;

    @action setPolicyAccepted = (value) => {
        this.policyAccepted = value;
    };

    @action setMarketingAccepted = (value) => {
        this.marketingAccepted = value;
    };

    @action handleAccept = () => {
        if (!this.policyAccepted || this.submitting) {
            return;
        }

        this.submitting = true;
        this.errorMessage = null;

        Requester.post(CONSENT_ENDPOINT, {
            policyAccepted: true,
            marketingAccepted: !!this.marketingAccepted,
        })
            .then(
                action(() => {
                    this.submitting = false;
                    this.props.onAccepted();
                }),
            )
            .catch(
                action(() => {
                    this.errorMessage = translate("privacy.error");
                    this.submitting = false;
                }),
            );
    };

    handleReject = () => {
        this.props.onRejected();
    };

    render() {
        const { policyUrl } = this.props;

        return (
            <div className={styles.backdrop}>
                <div className={styles.panel}>
                    <h2 className={styles.title}>
                        {translate("privacy.title")}
                    </h2>
                    <p className={styles.intro}>{translate("privacy.intro")}</p>

                    <div className={styles.consentRow}>
                        <Toggler
                            checked={this.policyAccepted}
                            onChange={this.setPolicyAccepted}
                        >
                            {translate("privacy.policy_consent")}
                            {policyUrl && (
                                <Fragment>
                                    {" "}
                                    <a
                                        href={policyUrl}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        {translate("privacy.policy_link")}
                                    </a>
                                </Fragment>
                            )}
                        </Toggler>
                    </div>

                    <div className={styles.consentRow}>
                        <Toggler
                            checked={this.marketingAccepted}
                            onChange={this.setMarketingAccepted}
                        >
                            {translate("privacy.marketing_consent")}
                        </Toggler>
                    </div>

                    {this.errorMessage && (
                        <div className={styles.error}>{this.errorMessage}</div>
                    )}

                    <div className={styles.actions}>
                        <Button skin="secondary" onClick={this.handleReject}>
                            {translate("privacy.reject")}
                        </Button>
                        <Button
                            disabled={!this.policyAccepted || this.submitting}
                            loading={this.submitting}
                            onClick={this.handleAccept}
                            skin="primary"
                        >
                            {translate("privacy.accept")}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default PrivacyConsentDialog;
